import React from 'react'

function ErrorComponent() {
    return <div>A ocurrido un error, si este persiste contacte a servicio tecnico</div>
}

export default ErrorComponent